import { combineReducers } from 'redux';
import {
  processes,
  policyHolders,
  broker,
  user
} from '_/modules/ProcessList/reducer';
import policyDetail from '_/modules/ProcessDetail/reducer';

/**
 * Exporting all the combined reducers from the services.
 */
export default combineReducers({
  processes,
  policyHolders,
  policyDetail,
  login: broker,
  user
});
